//Just to ensure prototype functionality
$(document).ready(function () {

    //Fix buy button in header
    var $headerButton = $('.js-header-button');
    var $buyButton = $('.sticky-header-buy-button');
    var attributes = $buyButton.prop("attributes");
    if ($buyButton.length) {
        $.each(attributes, function() {
            $headerButton.attr(this.name, this.value);
        });
    }

    //Fix safari issue with back-forward cache.
    $(window).bind('pageshow', function(event) {
        if (event.originalEvent.persisted) {
            window.location.reload()
        }
    });


    //Cbox setting
    $.colorbox.settings.opacity = 0.5;
    $.colorbox.settings.inline = !0;

    var cboxOptions = {
        width: '80%',
        maxWidth: '938px',
        height: '673px'
    }

    //WantConsole-FromBuy
    $('.popup-wantconsole--buy').on('click', function (event) {
        event.preventDefault();

        //colorbox
        $(this).colorbox({
            href: '#popup-wantconsole--buy',
            width: window.innerWidth > parseInt(cboxOptions.maxWidth) ? cboxOptions.maxWidth : cboxOptions.width,
            height: cboxOptions.height,

            onComplete: function () {
                window.location.hash = 'smb-wantconsole-buy'

                //Fill managed/unmanaged buttons with url to the cart
                //now without cookies and parameters (refresh doesnt work)
                $('#noConsoleLink').attr('href', $(this).attr('data-unmanaged'));
                $('#withConsoleLink').attr('href', $(this).attr('data-managed'));                

                //Spinner on "loading cart"
                $('#noConsoleLink, #withConsoleLink').on('click', function () {
                    $('#cboxContent').append('<span class="spiner"></span>');
                    $('#cboxLoadedContent').addClass('loading');
                });
            },
            onClosed: function () {
                window.location.hash = '!'
            }
        })
    });

    if (window.location.href.indexOf('smb-wantconsole-buy') > -1) {
        window.location.hash = '!'; //don't show popup when reload
    }

    //WantPatch-FromBuy
    $('.popup-wantpatch--buy').on('click', function (event) {
        event.preventDefault();

        //colorbox
        $(this).colorbox({
            href: '#popup-wantpatch--buy',
            width: window.innerWidth > parseInt(cboxOptions.maxWidth) ? cboxOptions.maxWidth : cboxOptions.width,
            height: cboxOptions.height,

            onComplete: function () {
                window.location.hash = 'smb-wantpatch-buy'

                //Fill managed/unmanaged buttons with url to the cart
                //now without cookies and parameters (refresh doesnt work)
                $('#noPatchLink').attr('href', $(this).attr('data-nopatch'));
                $('#withPatchLink').attr('href', $(this).attr('data-patch'));                

                //Spinner on "loading cart"
                $('#noConsoleLink, #withConsoleLink').on('click', function () {
                    $('#cboxContent').append('<span class="spiner"></span>');
                    $('#cboxLoadedContent').addClass('loading');
                });
            },
            onClosed: function () {
                window.location.hash = '!'
            }
        })
    });

    if (window.location.href.indexOf('smb-wantpatch-buy') > -1) {
        window.location.hash = '!'; //don't show popup when reload
    }


    //WantConsole-FromTrial
    $('.popup-wantconsole--trial').on('click', function (event) {
        event.preventDefault();

        //fill data-sku from root link
        var sku = $(this).data('sku'),
            skuManaged = $(this).data('sku-managed');

        $('.download-trial-unmanaged-v2').data('sku', sku);
        $('.popup-whichconsole--trial').data('sku', skuManaged);

        //Set trial edition for managed products
        if (typeof URL === "function") { 
            var $trialManagedButton = $('.download-trial-managed'),
            trialHref = new URL($trialManagedButton.attr('href'));

            trialHref.searchParams.set('trialProducts', getTriaManagedEdition(skuManaged));
            $trialManagedButton.attr('href', trialHref);
        }

        //colorbox
        $(this).colorbox({
            href: '#popup-wantconsole--trial',
            width: window.innerWidth > parseInt(cboxOptions.maxWidth) ? cboxOptions.maxWidth : cboxOptions.width,
            height: cboxOptions.height,

            onComplete: function () {
                window.location.hash = 'smb-wantconsole-trial',
                    $.colorbox.resize()
            },
            onClosed: function () {
                window.location.hash = '!';
            }
        })
    });

    if (window.location.href.indexOf('smb-wantconsole-trial') > -1) {
        //$('#top .popup-wantconsole--trial').click();
        //window.location.hash = 'smb-wantconsole-trial';
        window.location.hash = '!'; //don't show popup when reload
    }


    //WhichConsole
    $('.popup-whichconsole--trial').on('click', function (event) {
        event.preventDefault();
        var $thatLink = $(this);

        $(this).colorbox({
            href: '#popup-whichconsole--trial',
            width: window.innerWidth > parseInt(cboxOptions.maxWidth) ? cboxOptions.maxWidth : cboxOptions.width,
            height: cboxOptions.height,

            onLoad: function () {
                var sku = $thatLink.data('sku');
                window.location.hash = 'smb-whichconsole-trial', $('.ajax-loader').css({
                        display: 'block'
                    }),
                    $('#whichConsole').load('smb-trial-managed2018-form?sku=' + sku, function () {
                        $('#whichConsole .ajax-loader').hide();
                        initAvastForm();
                        $.colorbox.resize();
                        $('#whichConsole .avast-form').on('submit', function () {
                            $.colorbox.resize()
                        });
                        // do not remove - set hidden choice input which is used on form backend
                        $('#whichConsole .avast-form').on('click', '.choice-button', function () {
                            $('input[name="choice"]').val($(this).data('choice'));
                            $('#whichConsole .avast-form').trigger('submit');
                        });
                    })
            },
            onClosed: function () {
                $('#whichConsole').empty(),
                    window.location.hash = '!'
            }
        })
    });

    if (window.location.href.indexOf('smb-whichconsole-trial') > -1) {
        //$('.popup-whichconsole--trial').click();
        //window.location.hash = 'smb-whichconsole-trial';
        window.location.hash = '!'; //don't show popup when reload
    }


    //UNmanaged trial user details
    $('.download-trial-unmanaged-v2').on('click', function (event) {
        event.preventDefault();
        var $thatLink = $(this);

        $(this).colorbox({
            href: '#popup-userdetails--trial',
            width: window.innerWidth > parseInt(cboxOptions.maxWidth) ? cboxOptions.maxWidth : cboxOptions.width,
            height: cboxOptions.height,

            onLoad: function () {
                var sku = $thatLink.data('sku');
                window.location.hash = 'smb-user-details', $('.ajax-loader').css({
                        display: 'block'
                    }),
                    $('#trialForm').load('smb-trial-unmanaged2018-form?sku=' + sku, function () {
                        $('#formPopup .ajax-loader').hide();
                        initAvastForm();

                        $('#trialForm .avast-form').on('submit', function () {
                            $.colorbox.resize()
                        });

                        $('.product-name-placeholder').text(getProductName(sku)); //show product name

                        //disable submit
                        var $submit = $('#trialForm input[type="submit"]');
                        var $input = $('#trialForm input[required]');

                        var isValid = true;
                        $submit.prop('disabled', true);

                        $input.keyup(function () {
                            $input.each(function () {
                                if ($.trim($(this).val()) == '') {
                                    isValid = false;
                                    return false;
                                } else {
                                    isValid = true;
                                }
                            });
                            if (isValid == false)
                                $submit.prop('disabled', true);
                            else
                                $submit.prop('disabled', false);
                        });
                        $.colorbox.resize();
                    });
            },
            onClosed: function () {
                $('#trialForm').empty(),
                    window.location.hash = '!'
            }
        })
    });

    if (window.location.href.indexOf('smb-user-details') > -1) {
        //$('.download-trial-unmanaged-v2').click();
        //window.location.hash = 'smb-user-details';
        window.location.hash = '!'; //don't show popup when reload
    }

});


function getProductName(sku) {
    if (sku == 'bus.1.1m') {
        return 'Business Antivirus'
    }
    else if (sku == 'bug.1.1m') {
        return 'Business Antivirus Pro'
    }
    else if (sku == 'bup.1.1m') {
        return 'Business Antivirus Pro Plus'
    }
    else {
        return ('Product')
    }
}


function getTriaManagedEdition(sku) {
    if (sku == 'bms.100.1m') {
        return 'EDITION_1'
    }
    else if (sku == 'bmg.100.1m') {
        return 'EDITION_2'
    }
    else if (sku == 'bmp.100.1m') {
        return 'EDITION_3'
    }
    else {
        return ('EDITION_3')
    }
}
